import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function SuccessPage() {
    const navigate = useNavigate();

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.iconWrap}>
                    <svg viewBox="0 0 52 52" style={styles.icon}>
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#22c55e" strokeWidth="2" />
                        <path fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
                            d="M14 27 l9 9 l16-18" />
                    </svg>
                </div>
                <h1 style={styles.heading}>You're in.</h1>
                <p style={styles.sub}>
                    Payment confirmed. Your subscription is active.
                </p>
                <button style={styles.btn} onClick={() => navigate('/dashboard')}>
                    Go to Dashboard
                </button>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #031f4a 0%, #0a2a5e 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Inter, system-ui, Arial, sans-serif',
        padding: '24px',
    },
    card: {
        background: '#fff',
        borderRadius: '20px',
        padding: '56px 48px',
        textAlign: 'center',
        maxWidth: '420px',
        width: '100%',
        boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
    },
    iconWrap: {
        marginBottom: '28px',
    },
    icon: {
        width: '72px',
        height: '72px',
    },
    heading: {
        fontSize: '2rem',
        fontWeight: '800',
        color: '#031f4a',
        margin: '0 0 12px',
    },
    sub: {
        fontSize: '1rem',
        color: '#64748b',
        lineHeight: '1.6',
        margin: '0 0 36px',
    },
    btn: {
        background: 'linear-gradient(135deg, #0a2a5e, #031f4a)',
        color: '#fff',
        border: 'none',
        borderRadius: '12px',
        padding: '14px 36px',
        fontSize: '1rem',
        fontWeight: '700',
        cursor: 'pointer',
        width: '100%',
        letterSpacing: '0.3px',
        transition: 'opacity 0.2s',
    },
};
